/**
 * Service Worker Registrierung
 *
 * In der Produktion nutzt die App einen Service Worker für
 * Offline-Fähigkeit und schnelleres Laden beim Folgebesuch.
 * In der Entwicklung ist der Service Worker deaktiviert.
 */

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/,
  ),
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      // Auf localhost prüfen, ob der SW noch gültig ist
      checkValidServiceWorker(swUrl, config);
      navigator.serviceWorker.ready.then(() => {
        console.log(
          "[PWA] App wird durch einen Service Worker gecacht (localhost).",
        );
      });
    } else {
      registerValidSW(swUrl, config);
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Neue Inhalte verfügbar – nach Reload aktiv
              console.log(
                "[PWA] Neuer Inhalt verfügbar. Seite neu laden zum Aktualisieren.",
              );
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Erstmalig gecacht
              console.log("[PWA] Inhalte für Offline-Nutzung gecacht.");
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error(
        "[PWA] Service Worker Registrierung fehlgeschlagen:",
        error,
      );
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // Service Worker nicht gefunden – App neu laden
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "[PWA] Keine Internetverbindung – App läuft im Offline-Modus.",
      );
    });
}
